import React from 'react';
import CardContainer from 'src/components/CardContainer/CardContainer';
import { KnowledgeBases } from 'src/pages/ControlDeskPage/DataSourceSection/KnowledgeBases/KnowledgeBases';
import { clsx } from 'clsx';
import { useParams } from 'react-router-dom';
import { useGetProjectByIdQuery } from 'src/services';
import { useAppSelector } from 'src/store';

export const DataSourceSection = () => {
  const { isInactivePlan } = useAppSelector((s) => s.planSlice);
  const { id } = useParams();

  const { data: currentProject } = useGetProjectByIdQuery({ id: id }) as any;

  return (
    <CardContainer className="h-full flex-1">
      <div
        className={clsx(
          (!currentProject?.is_active || isInactivePlan) && 'opacity-30 pointer-events-none',
          'card-header z-50',
        )}
      >
        <div className="title cursor-default">
          <span className="!no-underline max-md:hidden text-sm font-bold text-[#7A6BE5]">
            Assigned Knowledge Bases
          </span>
        </div>
      </div>
      <div
        className={clsx(
          (!currentProject?.is_active || isInactivePlan) && 'opacity-30 pointer-events-none',
          'card-body flex w-full gap-2.5 max-md:flex-col !mt-2.5',
        )}
      >
        <KnowledgeBases />
      </div>
    </CardContainer>
  );
};
